import { render } from "./portfolio.vue?vue&type=template&id=74f41b80&scoped=true"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"

import "./portfolio.vue?vue&type=style&index=0&id=74f41b80&scoped=true&lang=css"

import exportComponent from "/home/kira/project/web/SPACDYNA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f41b80"]])

export default __exports__